import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * State and feedback — §5.
 *
 * The house rule: state is a WORD carrying the meaning, plus a 2px rule
 * reinforcing it. Never colour alone, never a filled block.
 */
import { Button as AriaButton } from 'react-aria-components';
const BADGE_CLASS = {
    none: 'badge-none',
    generating: 'badge-gen',
    'needs-ok': 'badge-ok',
    ready: 'badge-ready',
    error: 'badge-err',
};
const DOT_CLASS = {
    none: 'dot-none',
    generating: 'dot-gen',
    'needs-ok': 'dot-ok',
    ready: 'dot-ready',
    error: 'dot-err',
};
/** The bare status dot — the rail's sibling rows and the floor use it alone. */
export function StatusDot({ status }) {
    return _jsx("span", { className: `dot ${DOT_CLASS[status]}`, "aria-hidden": "true" });
}
/** The three blinking dots that mean "still working". Decorative; the word carries it. */
export function WorkingDots() {
    return (_jsxs("span", { className: "dots", "aria-hidden": "true", children: [_jsx("i", {}), _jsx("i", {}), _jsx("i", {})] }));
}
export function StatusBadge({ status, children }) {
    return (_jsxs("span", { className: `badge ${BADGE_CLASS[status]}`, children: [status === 'generating' ? null : status === 'none' ? null : _jsx(StatusDot, { status: status }), children, status === 'generating' && _jsx(WorkingDots, {})] }));
}
/** The compact reusable indicator — the top bar's "N making" is one of these. */
export function InlineStatus({ status = 'generating', children }) {
    return (_jsxs("span", { className: "gstat", children: [status === 'generating' ? _jsx(WorkingDots, {}) : _jsx(StatusDot, { status: status }), _jsx("b", { children: children })] }));
}
/** Cost — mono, flat, no pressure. `emphasis` is the number, never a warning. */
export function CostLabel({ children, emphasis, }) {
    return (_jsxs("span", { className: "cost", children: [children, emphasis !== undefined && _jsx("b", { children: emphasis })] }));
}
export function Progress({ label, value }) {
    const determinate = value !== undefined;
    return (_jsx("span", { className: "prog", role: "progressbar", "aria-label": label, "aria-valuenow": determinate ? value : undefined, "aria-valuemin": determinate ? 0 : undefined, "aria-valuemax": determinate ? 100 : undefined, "data-determinate": determinate ? '' : undefined, children: _jsx("i", { style: determinate ? { width: `${value}%` } : undefined }) }));
}
export function Avatar({ initials, label, onClick, trigger = false, size = 'md', }) {
    const classes = size === 'lg' ? 'avatar avatar-lg' : 'avatar';
    if (onClick === undefined && !trigger) {
        return (_jsx("span", { className: classes, role: "img", "aria-label": label, children: initials }));
    }
    // A React Aria `Button`, so that inside a `MenuTrigger` it becomes the trigger through
    // RAC's own context — no press handler of its own, and no second source of truth for open.
    return (_jsx(AriaButton, { className: classes, "aria-label": label, ...(onClick === undefined ? {} : { onPress: onClick }), children: initials }));
}
//# sourceMappingURL=Status.js.map